const cloudName = "dmr4kfndo";

export const getCDNUrl = (filename, options =  "q_auto,f_auto") => 
    `https://res.cloudinary.com/${cloudName}/image/upload/${options}/${filename}`;
